@import (reference) '../../../../../../constants/spacing.module.less';
@import (reference) '../../../../../../constants/screen-width-breakpoints.module.less';

.modal {
  @media @tablet, @desktop, @widescreen, @ultrawide {
    width: 600px;
    max-height: 650px;
  }
}

.modal-body {
  padding: @space-24;
}

.date-picker {
  display: flex;
  height: 32px;
  width: 100%;
  background-color: var(--white);
  input {
    height: 32px;
    border: 1px solid var(--grey-500);
    border-right: none;
  }
  button {
    height: 32px;
    border: 1px solid var(--grey-500);
    display: flex;
  }
}

.caption-box {
  padding: @space-12;
  background-color: var(--grey-200);
  border: 1px solid var(--grey-200);
  border-radius: @space-4;
}

.notes-input-wrapper {
  min-height: 68px;
}

.modal-footer-with-delete {
  justify-content: space-between;
}
